export default "__VITE_ASSET__BwwZwMuu__"